export default "mutation RefreshDeviceToken($deviceId: ID!) {\n  refreshDeviceToken(\n    deviceId: $deviceId\n  )\n}\n"